import React,  {Component} from 'react'; 
import getPerformancesIntervallByTheatre from '../functions/getPerformancesIntervallByTheatre'
import MovieTimesPeriodeDaysItemsDesktop from './MovieTimesPeriodeDaysItemsDesktop'
import getTranslationTime from '../functions/getTranslationTime';
import Translation from '../General/Translation';
import sortAlphabetical from '../functions/sortAlphabetical';
import getDayKey from '../functions/getDayKey';
import getMomentNow from '../functions/getMomentNow';
import { compose } from 'redux';
import { connect } from 'react-redux';
import toJS from '../hoc/toJS';
import { FRONT, TRANSLATION } from '../constants/state';
import getData from '../functions/getData';
import ItemAttributesContainer from '../PosterFormatItem/ItemAttributesContainer';


const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT),
    translation: getData(state, TRANSLATION)
})

class MovieTimesTheatreContainer extends Component {
    constructor (props) {
        super(props) 
    }

    getSortedTheatreObjects(theatreKeys, theatreObjects) {
        const sortedTheatres = theatreKeys.sort(function(a, b) {
            const theatreA = theatreObjects[a]
            const theatreB = theatreObjects[b]

            const aName = theatreA.name
            const bName = theatreB.name
            
            return bName > aName ? -1 : bName < aName ? 1 : 0
        })
    
        return sortedTheatres
    }

    render() {
        const { 
            movieId, 
            movieTitle, 
            performances, 
            activePerformance, 
            alternativeLinks,
            translation, 
            today, 
            scrollToPosition, 
            onOpenIframe, 
            queryStringValues,
            cinemaDataFront 
        } = this.props
        const {show_performancePrice} = cinemaDataFront
        const { timezone } = translation
        const dateNow = getMomentNow(timezone)
        const theatres = getPerformancesIntervallByTheatre(performances, today, dateNow, timezone, queryStringValues)
        
        if(!theatres) {
            return ''
        }

        const { dayIntervallObject, dayIntervallKeys, theatreObjects } = theatres
        const todayKey = getDayKey(today)
        const className = 'movie-times-desktop movie-times-days-' + dayIntervallKeys.length
        const sortedTheatreObjectKeys = this.getSortedTheatreObjects(Object.keys(theatreObjects), theatreObjects)

        return (
            <div className={className}>
                <div className="movie-times-grid">
                    {dayIntervallKeys.map((dayKey, index) => {
                        const isToday = todayKey === dayKey 
                        const dayFormarted= isToday ? <Translation id="today" trans={translation}>Heute</Translation> : getTranslationTime('performanceDates', translation, dayKey) 
                        const additionalClass = isToday ? "accent-color-background" : "accent-color-background-dark"
                        const noPerformancesClass = isToday ? '' : (dayIntervallObject[dayKey][0] ? '' : ' no-performances')

                        return <div className={"date text-light " + additionalClass + noPerformancesClass} key={index}>{dayFormarted}</div>
                    })}
                </div>

                <div>
                    {sortedTheatreObjectKeys.map((theatreKey, index) => {
                        const theatre = theatreObjects[theatreKey]
                        const { name, attributes, dayIntervall } = theatre
                        let attributesSorted

                        if(dayIntervall.length > 0) {
                            return ''
                        }
                        
                        if(attributes) {
                            attributesSorted = sortAlphabetical(attributes)
                        }
                        
                        return (
                            <div key={index}>
                                <div className="theatre-and-attributes-wrapper">
                                    <div className="title-xlarge-theatre theatre">{name}</div>
                                    <div className="attributes">
                                        {attributes && attributesSorted && <ItemAttributesContainer attributes={attributesSorted} canBeColored={true} />}
                                    </div>
                                </div>
                                <div className="movie-times-grid">
                                    {dayIntervallKeys.map((dayKey, index) => {
                                        const performances = dayIntervall[dayKey]
                                        const isToday = todayKey === dayKey 
                                        const additionalClass = isToday ? "is-today" : ""

                                        return (
                                            <div key={index} className={'performances-wrapper ' + additionalClass}>
                                                {performances && <MovieTimesPeriodeDaysItemsDesktop
                                                    movieId={movieId}
                                                    movieTitle={movieTitle}
                                                    performances={performances}
                                                    showPerformancePrice={show_performancePrice}
                                                    activePerformance={activePerformance}
                                                    alternativeLink={alternativeLinks}
                                                    translation={translation}
                                                    scrollToPosition={scrollToPosition}
                                                    onOpenIframe={onOpenIframe}
                                                    dateNow={dateNow}
                                                />}
                                            </div>  
                                        )

                                    })}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(MovieTimesTheatreContainer)